import { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { createTiles } from '@parlaygames/bingo-utility';
import { CommonPanel } from '../CommonPanel';
import { CallBoardNumber } from '../CallBoardNumber';

export type CallBoard30Props = HTMLAttributes<HTMLDivElement> & {
    called: number[];
    fireBall?: number;
    fireBallSnuffed?: boolean;
};

export const CallBoard30Container = styled(CommonPanel)`
    box-shadow: none;
    background-image: none;
    overflow: visible;
    padding: 0;
    caret-color: transparent;
`;

const CallBoard30Number = styled(CallBoardNumber)`
    line-height: 1.91;
    margin: 0;
    padding: 0;
    font-size: 1.5rem;
    height: 2.5rem;
    text-align: center;
`;

export const SquareContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0.63rem 2.5rem;
    background-color: ${({ theme }) => theme.callBoard.board30.background};
    align-items: center;
`;

export const TILES = createTiles(1, 30, 10, false);

export const CallBoard30: FC<CallBoard30Props> = ({
    called,
    fireBall,
    fireBallSnuffed,
    ...props
}) => {
    return (
        <CallBoard30Container type="secondary" {...props}>
            {TILES.map((tiles, index) => {
                return (
                    <SquareContainer key={index}>
                        {tiles.map((tile) => (
                            <CallBoard30Number
                                number={tile}
                                isCalled={called.includes(tile)}
                                isFireBall={!!fireBall && tile === fireBall}
                                isFireBallSnuffed={fireBallSnuffed}
                                key={tile}
                            >
                                {tile}
                            </CallBoard30Number>
                        ))}
                    </SquareContainer>
                );
            })}
        </CallBoard30Container>
    );
};
